<template>
  <v-flex
    class="weather-comp"
    xs3
    sm3
    md3
    lg2
    v-if="zone1active || zone2active || zone3active || zone4active"
  >
    <v-layout row class="main-page-list">
      <v-flex xs6>{{ "lng_weather_comp_short" | translate }}</v-flex>
      <v-flex xs3 v-if="zone1active">{{ "lng_zone_1" | translate }}</v-flex>
      <v-flex xs3 v-if="zone2active">{{ "lng_zone_2" | translate }}</v-flex>
      <v-flex xs3 v-if="zone3active">{{ "lng_zone_3" | translate }}</v-flex>
      <v-flex xs3 v-if="zone4active">{{ "lng_zone_4" | translate }}</v-flex>
    </v-layout>
    <v-layout
      row
      class="main-page-list"
      v-for="data in weatherData"
      :key="data.label"
    >
      <v-flex xs6>{{ data.label | translate }}</v-flex>
      <v-flex xs3 v-if="zone1active"
        >{{ data.zone1.val }} {{ data.zone1.unit | translate }}</v-flex
      >
      <v-flex xs3 v-if="zone2active"
        >{{ data.zone2.val }} {{ data.zone2.unit | translate }}</v-flex
      >
      <v-flex xs3 v-if="zone3active"
        >{{ data.zone3.val }} {{ data.zone3.unit | translate }}</v-flex
      >
      <v-flex xs3 v-if="zone4active"
        >{{ data.zone4.val }} {{ data.zone4.unit | translate }}</v-flex
      >
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  data() {
    return {
      weatherData: [
        {
          key: "wanted",
          label: "lng_weather_14"
        },
        {
          key: "actual",
          label: "lng_weather_11"
        },
        {
          key: "valve",
          label: "lng_weather_15"
        },
        {
          key: "calc",
          label: "lng_weather_13"
        },
        {
          key: "actualref",
          label: "lng_weather_12"
        },
        {
          key: "roomcomp",
          label: "lng_zone_roomcomp"
        },
        {
          key: "roomref",
          label: "lng_zone_roomref"
        }
      ],
      zone1active: this.controllerData.zone1active === 1 ? true : false,
      zone2active: this.controllerData.zone2active === 1 ? true : false,
      zone3active: this.controllerData.zone3active === 1 ? true : false,
      zone4active: this.controllerData.zone4active === 1 ? true : false
    };
  },
  props: {
    controllerData: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.getWeatherData(this.controllerData);
  },
  watch: {
    controllerData: function(newVal) {
      (this.zone1active = newVal.zone1active === 1 ? true : false),
        (this.zone2active = newVal.zone2active === 1 ? true : false),
        (this.zone3active = newVal.zone3active === 1 ? true : false),
        (this.zone4active = newVal.zone4active === 1 ? true : false),
        this.getWeatherData(newVal);
    }
  },
  methods: {
    getWeatherData(contData) {
      this.weatherData.forEach(element => {
        if (contData.zone1active === 1) {
          element.zone1 = contData["zone1-" + element.key];
        }
        if (contData.zone2active === 1) {
          element.zone2 = contData["zone2-" + element.key];
        }
        if (contData.zone1active === 1) {
          element.zone3 = contData["zone3-" + element.key];
        }
        if (contData.zone1active === 1) {
          element.zone4 = contData["zone4-" + element.key];
        }
      });
    }
  }
};
</script>
